import { useQuery } from 'react-query';
import { usePersonId } from 'src/components/providers/PersonIdProvider';
import { api } from '../../helpers';
export const useAnamnesisById = ({
  anamnesisReferenceId,
  onSuccess,
  enabled = true
}) => {
  const personReferenceId = usePersonId();
  return useQuery(['anamnesis', personReferenceId, anamnesisReferenceId], () => api.ana.getAnamnesisById({
    personReferenceId,
    anamnesisReferenceId
  }).then(res => {
    onSuccess && onSuccess(res);
    return res;
  }), {
    enabled: enabled && Boolean(personReferenceId && anamnesisReferenceId)
  });
};